"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Types = require("../util/Types");
var _CustomLinkView = _interopRequireDefault(require("./components/CustomLinkView"));
var _DataFormatView = _interopRequireDefault(require("./components/DataFormatView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
/**
* Custom Column reneder
*/
var CustomComponent = function CustomComponent(_ref) {
  var row = _ref.row,
    column = _ref.column;
  var dataField = column.dataField,
    customCellRender = column.customCellRender;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, customCellRender(_objectSpread(_objectSpread(_objectSpread({}, row), column), {}, {
    label: row[dataField]
  })));
};

/**
* data display columns
* @returns default/Link/Custom view
*/
var ViewCell = function ViewCell(_ref2) {
  var column = _ref2.column,
    row = _ref2.row;
  var cellType = column.cellType;
  switch (cellType) {
    case _Types.cellTypes.FORMAT_DATA:
      return /*#__PURE__*/_react.default.createElement(_DataFormatView.default, {
        row: row,
        column: column
      });
    case _Types.cellTypes.LINK:
      return /*#__PURE__*/_react.default.createElement(_CustomLinkView.default, {
        row: row,
        column: column
      });
    case _Types.cellTypes.CUSTOM_ELEM:
      return /*#__PURE__*/_react.default.createElement(CustomComponent, {
        row: row,
        column: column
      });
    default:
      return /*#__PURE__*/_react.default.createElement(_core.Typography, null, row[column.dataField]);
  }
};
var DisplayCell = function DisplayCell(_ref3) {
  var row = _ref3.row,
    column = _ref3.column;
  return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    className: column.dataField
  }, /*#__PURE__*/_react.default.createElement(ViewCell, {
    row: row,
    column: column
  }));
};
var _default = DisplayCell;
exports.default = _default;